<template>
  <div>
    <div
      class="-mx-6 overflow-auto border-b border-gray-lighten1 px-2 md:mx-0 md:px-0"
    >
      <ul
        v-if="tabs.length"
        class="scrollbar-tiniest title flex h-[53px] gap-x-2 whitespace-nowrap text-lg leading-none text-slate-lighten4 scrollbar sm:h-[57px] xl:text-xl"
      >
        <li
          v-for="(tab, i) in tabs"
          :key="tab.value.name"
          :class="{ 'md:-ml-4': i === 0 }"
          @click="setActiveTab(tab.value.name, $event.target)"
        >
          <NuxtLink
            v-if="tab.value.link"
            :to="tabLink(tab.value.link)"
            :class="getTabClass(tab.value.name)"
          >
            {{ tab.value.text }}
          </NuxtLink>
          <button v-else :class="getTabClass(tab.value.name)">
            {{ tab.value.text }}
          </button>
        </li>
      </ul>
    </div>

    <slot v-if="navigation" />

    <div v-else class="py-6 md:py-8 xl:py-12">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useTabs } from '~/composables';

interface Props {
  navigation?: boolean;
}
defineProps<Props>();
const { tabs, activeTab, setActiveTab } = useTabs();
const route = useRoute();
const query = computed(() => route.query);

defineExpose({
  tabs,
  activeTab,
  setActiveTab,
});

const getTabClass = (name: string) => [
  'relative flex h-full items-center px-4 uppercase',
  {
    'text-blue before:absolute before:bottom-0 before:left-4 before:right-4 before:h-0.5 before:rounded-sm before:bg-blue':
      name === activeTab.value,
  },
];

const tabLink = (link?: string) =>
  link && {
    path: link,
    query: {
      search: query.value.search,
    },
  };
</script>
